var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import { t } from "../../I18N";
import I18NLink from "../../I18N/components/I18NLink";

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';


import { Icon } from "../../UI";

const defaultProps = {
  quickLabelThesaurus: undefined
};



export class QuickLabelHeaderBase extends Component {


  render() {
    const { quickLabelThesaurus } = this.props;
    const thesaurusName = quickLabelThesaurus ? quickLabelThesaurus.get('name') : '';
    return (/*#__PURE__*/
      _jsx("div", { className: "content-header" }, void 0,
      !thesaurusName && /*#__PURE__*/
      _jsx("div", { className: "content-header-title" }, void 0, /*#__PURE__*/
      _jsx("h1", {}, void 0,
      t('System', 'Ooops... please go'), "\xA0", /*#__PURE__*/

      _jsx(I18NLink, { className: "btn btn-default", to: "/settings/dictionaries" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "arrow-left" }), "\xA0", /*#__PURE__*/

      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Back to thesauri'))
      )
      )
      ),

      thesaurusName && /*#__PURE__*/
      _jsx("div", { className: "content-header-title" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, {
        className: "btn btn-default",
        to: `/settings/dictionaries/cockpit/${quickLabelThesaurus === null || quickLabelThesaurus === void 0 ? void 0 : quickLabelThesaurus.get('_id')}` }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "arrow-left" }), "\xA0", /*#__PURE__*/

      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Back to thesaurus'))
      ), /*#__PURE__*/
      _jsx("h1", {}, void 0, /*#__PURE__*/
      _jsx("span", { className: "large" }, void 0,
      t('System', 'Quick labeling for'), "\xA0", /*#__PURE__*/_jsx("b", {}, void 0, thesaurusName)
      )
      )
      )

      ));

  }
}_defineProperty(QuickLabelHeaderBase, "defaultProps", defaultProps);

export const selectquickLabelThesaurus = createSelector(
  (state) =>
  state.thesauris.find(
    (thes) => thes.get('_id') === state.library.sidepanel.quickLabelState.get('thesaurus')
  ),
  (thes) => thes
);

export const mapStateToProps = (state) => ({
  quickLabelThesaurus: selectquickLabelThesaurus(state)
});

export const QuickLabelHeader = connect(mapStateToProps)(QuickLabelHeaderBase);